var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3155_13325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.1667C11.8409 15.1667 13.3333 13.6743 13.3333 11.8333C13.3333 9.99238 11.8409 8.5 10 8.5C8.15905 8.5 6.66667 9.99238 6.66667 11.8333C6.66667 13.6743 8.15905 15.1667 10 15.1667Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 11.9163L9.24167 12.4579C9.4 12.6163 9.65833 12.6163 9.81667 12.4663L11.3 11.0996",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8083 11.6667L18.0917 8.69167C18.3083 6.65833 17.725 5 14.1667 5H5.83333C2.275 5 1.69167 6.65833 1.91667 8.69167L2.54167 15.3583C2.71667 16.9917 3.31667 18.3333 6.66667 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.99935V4.33268C6.66667 2.85768 6.66667 1.66602 9.33333 1.66602H10.6667C13.3333 1.66602 13.3333 2.85768 13.3333 4.33268V4.99935",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0417 9.16602C16.6 10.216 15 10.9493 13.3417 11.366",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18333 9.39258C3.575 10.3426 5.09167 11.0176 6.66667 11.4009",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3155_13325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDesignation);
export default __webpack_public_path__ + "static/media/activeDesignation.285618109c7e3d9efd3c972a66718524.svg";
export { ForwardRef as ReactComponent };